import { BuildQuickJournalStoredSnapshot } from "../Stats/QuickJournalStatsCore";
import { GetEntriesStorageValue } from "./QuickJournalEntryStorage";
import {
    GetAddedEntryCreatedAts,
    MergeRecentEntries,
} from "./QuickJournalEntryNormalization";
import { MergeQuickJournalHourlyCountMaps } from "../Stats/QuickJournalStatsCore";
import {
    IQuickJournalState,
    IQuickJournalStoredSnapshot,
} from "../QuickJournalTypes";

export function MergeSyncedSnapshot(
    currentState: IQuickJournalState,
    syncedSnapshot: IQuickJournalStoredSnapshot
): IQuickJournalState {
    const recentEntries = MergeRecentEntries(
        currentState.recentEntries,
        syncedSnapshot.recentEntries
    );
    const weeklyHourlyCounts = MergeQuickJournalHourlyCountMaps(
        currentState.weeklyHourlyCounts,
        syncedSnapshot.weeklyHourlyCounts
    );
    const mergedSnapshot = BuildQuickJournalStoredSnapshot(
        recentEntries,
        weeklyHourlyCounts
    );
    const currentSnapshot = BuildQuickJournalStoredSnapshot(
        currentState.recentEntries,
        currentState.weeklyHourlyCounts
    );

    if (
        GetEntriesStorageValue(mergedSnapshot) ===
        GetEntriesStorageValue(currentSnapshot)
    ) {
        return currentState;
    }

    const animatingEntryCreatedAt = GetAddedEntryCreatedAts(
        currentState.recentEntries,
        recentEntries
    );

    return {
        ...currentState,
        recentEntries,
        weeklyHourlyCounts,
        animatingEntryCreatedAt:
            animatingEntryCreatedAt.length > 0
                ? animatingEntryCreatedAt
                : currentState.animatingEntryCreatedAt,
    };
}
